module.exports = __webpack_public_path__ + "static/media/walletActive.1027e940.png";